import React from 'react';
import { getUrlLocale } from 'components/utils';
import { SearchInput, SearchFormStyled, SearchIcon} from "./searchInput.style"

const SearchForm = () => {
    let {language} = getUrlLocale();
    
    return ( 
        <SearchFormStyled action={`${language !== 'en' ? '/' + language : ''}/search/`} method="get">
            <SearchInput type="text" name="q" />
            <SearchIcon type="submit"/>
        </SearchFormStyled>
    );
};

export default SearchForm;